import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StartUpConfigUiService, LocalDataCacheService, ProcessCounterService, IdleTimeoutService } from '../../Core/Services';
import { take } from 'rxjs/operators';

@Component({
  selector: 'ras-session-expiry',
  templateUrl: './session-expiry.component.html'
})
export class SessionExpiryComponent implements OnInit {
  private subscription: Subscription;
  private sessionExpirySub: Subscription;
  private sessionExtendedSub: Subscription;
  private sessionExpiredSubscription: Subscription;

  public showModal: boolean = false;

  constructor(protected configService: StartUpConfigUiService,
    private idleTimeoutService: IdleTimeoutService,
    private counterService: ProcessCounterService, private localStorage: LocalDataCacheService) {
  }

  ngOnInit(): void {
    this.sessionExtendedSub = this.idleTimeoutService.sessionExtended$.subscribe({
      next: (isExtended) => {
        if (isExtended) {

          this.initialize();
        } else {
          this.handleSessionExpiry(true);

        }
      }
    });
  }

  private initialize(): void {
    this.sessionExpirySub = this.idleTimeoutService.checkToShowSessionExpiryModal()
      .subscribe({
        next: (response) => {
          this.showModal = response.notifyUser;
        }
      });

    this.sessionExpiredSubscription = this.idleTimeoutService.sessionExpired$
      .subscribe({
        next: (isExpired) => {
          if (isExpired) {
            this.handleSessionExpiry(false);
          }
        }
      });
  }

  private handleSessionExpiry(performRedirection: boolean): void {

    this.configService.sessionTrackingId$.pipe(take(1)).subscribe({
      next: (sessionTrackingId) => {

        if (sessionTrackingId &&
          !this.configService.hasSessionExpiryTriggeredFor(sessionTrackingId)) {
          this.configService.addSessionExpiryTrigger(sessionTrackingId);

          // Process session expiry counter

          this.localStorage.getLocalStorage().removeItem('PreviousQouteCount');
          this.localStorage.getLocalStorage().removeItem('PreviousQouteCountMob');
          this.localStorage.getLocalStorage().setItem('PreviousQouteCount', "1");
          this.localStorage.getLocalStorage().setItem('PreviousQouteCountMob', "1");
          this.counterService
            .processSessionExpiryCounter(sessionTrackingId)
            .pipe(take(1))
            .subscribe({
              next: (res) => {
                if (performRedirection) {
                  this.performRedirection();
                }
              }
            });
        }

        if (performRedirection) {
          this.performRedirection();
        }
      }
    });

  }

  private performRedirection(): void {
    this.configService.cmsUrl$.pipe(take(1)).subscribe({
      next: (cmsUrl) => {
        if (cmsUrl) {
          location.href = cmsUrl;
        }
      }
    });
  }

  private tryExtendSession(): void {
    this.idleTimeoutService.tryExtendSession()
      .pipe(take(1))
      .subscribe({
        next: (sessionExtended) => {
          //if (!sessionExtended) {
          //    this.handleSessionExpiry(true);
          //}
        }
      });
  }

  onCloseClicked(): void {
    this.tryExtendSession();
    this.showModal = false;
  }

  onOverlayClicked(): void {
    this.tryExtendSession();
    this.showModal = false;
  }

  onOkayClicked(): void {
    this.tryExtendSession();
    this.showModal = false;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.sessionExpirySub) {
      this.sessionExpirySub.unsubscribe();
    }

    if (this.sessionExtendedSub) {
      this.sessionExtendedSub.unsubscribe();
    }

    if (this.sessionExpiredSubscription) {
      this.sessionExpiredSubscription.unsubscribe();
    }
  }
}
